<template v-once>
  <img src="@/assets/icons/optimizerx_icon.png" alt="OptimizeRx">
</template>

<script>
export default {
  name: "OptimizeRx",
};
</script>

<style scoped>
</style>
